


















































import { Component, Vue } from 'vue-property-decorator'
import { CustomerLeadEmployee } from '@immosparrow/cockpit-middleware-client'
import moment from 'moment'

@Component
export default class AgentInfo extends Vue {
  get agent (): CustomerLeadEmployee {
    return this.$store.getters.agentInfo
  }

  get id () {
    return this.$route.query?.leadListId as string
  }

  get lang () {
    return this.$store.getters.language
  }

  get agentPhotoUrl () {
    return this.agent?.photoUrl
  }

  get agentPhoto () {
    return `${process.env.VUE_APP_BASE_URL}${this.agent?.photoUrl}`
  }

  get agencyUrl () {
    return this.agent?.agencyLogoUrl
  }

  get logo () {
    return `${process.env.VUE_APP_BASE_URL}${this.agencyUrl}`
  }

  get fullName () {
    return `${this.agent?.firstName || ''} ${this.agent?.lastName || ''}`
  }

  get agentInitials () {
    if (!this.agent?.firstName || !this.agent?.lastName) return ''
    return `${this.agent?.firstName?.charAt(0).toUpperCase()}${this.agent?.lastName?.charAt(0).toUpperCase()}`
  }

  get email () {
    return this.agent?.email
  }

  get phone () {
    return this.agent?.workPhone
  }

  get date () {
    if (this.mailInfo?.length) {
      moment.locale(this.lang)
      return moment.utc(this.mailInfo[0].sentTime.getTime()).local().format('D MMMM YYYY, HH:mm')
    }
  }

  get content () {
    if (this.mailInfo?.length) {
      return this.mailInfo[0].content
    }
  }

  get mailInfo () {
    return this.$store.getters.lastMailInfo
  }
}
